import React, {useEffect} from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

import Login from './pages/Login';
import Onboarding from './pages/OnBoarding/Onboarding';
import Home from './contenedor/Home';
import  {fetchUser}  from './utils/fetchUser';

import './App.css';
import { useStateContext } from './contexts/ContextProvider';


const App = () => {
  const {currentMode, setCurrentColor, setCurrentMode, activeMenu, currentColor, themeSettings, setThemeSettings, isAuthenticated, setIsAuthenticated } = useStateContext();

  const navigate = useNavigate();

  useEffect(() => {

  const User = fetchUser();

  if (!User) {
    navigate('/login');
  }

  }, []);

  return (

    <Routes>
      <Route path="login" element={<Login />} />
      <Route path="/*" element={<Home />} />
      <Route path="/onboarding" element={<Onboarding />} />
    </Routes>

  );
};

export default App;